import { IPersonalAccidentAgeDetails, IPersonalAccidentQuotation } from "../../../../modules/personalAccident/utils/interfaces";
import { RootState } from "../../../store";
import { createSlice } from "@reduxjs/toolkit";

interface IDetails {
  AgeDetails: IPersonalAccidentAgeDetails;
  leadDetails: IPersonalAccidentQuotation;
  quoteID: string | undefined;
  dob: string;
  beneficiaryDetails?: any;
}

const initialState: IDetails = {
  AgeDetails: {},
  dob: "",
  leadDetails: {},
  quoteID: undefined,
  beneficiaryDetails: {}
};

// eslint-disable-next-line import/no-unused-modules
export const userDetails = createSlice({
  name: "user",
  initialState,
  reducers: {
    AddDetails: (state, payload) => {
      state.AgeDetails = payload.payload;
    },
    AddDOB: (state, payload) => {
      state.dob = payload.payload;
    },
    AddLeadDetails: (state, payload) => {
      state.leadDetails = payload.payload;
    },
    AddQuoteId: (state, payload) => {
      state.quoteID = payload.payload;
    },
    AddBeneficiaryDetails: (state, payload) => {
      state.beneficiaryDetails = payload.payload;
    },
    // eslint-disable-next-line no-param-reassign, no-unused-vars, @typescript-eslint/no-unused-vars
    ResetUser: state => (state = initialState)
  }
});

// Action creators are generated for each case reducer function
export const { AddDetails, AddLeadDetails, AddQuoteId, ResetUser, AddDOB, AddBeneficiaryDetails } = userDetails.actions;

export default userDetails.reducer;

export const getUserDetails = (state: RootState): IDetails => state.user;
export const getLeadDetails = (state: RootState): IPersonalAccidentQuotation => state.user.leadDetails;
export const getBeneficiaryDetails = (state: RootState): any => state.user.beneficiaryDetails;
